// extracted by mini-css-extract-plugin
export default {"main":"appLoader_main__vhJi4"};